import { type CSSProperties, memo } from 'react';

import { type PresentationContentLinksBlockOutput } from '@air/api/types';
import { Button } from '@air/primitive-button';

export type PublicShowcaseLinksBlockPillProps = {
  /** Brand-colored button override (from the link's customColors); undefined falls through to the default blue. */
  brandedStyle?: CSSProperties;
  /** Validated http/https destination; undefined renders the pill as non-clickable text. */
  href?: string;
  label: string;
  linkId: string;
  size: PresentationContentLinksBlockOutput['size'];
};

export const PublicShowcaseLinksBlockPill = memo(
  ({ brandedStyle, href, label, linkId, size }: PublicShowcaseLinksBlockPillProps) => {
    return (
      <Button appearance="filled" asChild color="blue" size={size} style={brandedStyle}>
        {href ? (
          <a
            aria-label={!label ? href : undefined}
            data-link-id={linkId}
            data-testid="PUBLIC_COLLECTION_LINKS_BLOCK_LINK"
            href={href}
            rel="noopener noreferrer nofollow"
            target="_blank"
          >
            {label}
          </a>
        ) : (
          <span data-link-id={linkId} data-testid="PUBLIC_COLLECTION_LINKS_BLOCK_LINK">
            {label}
          </span>
        )}
      </Button>
    );
  },
);

PublicShowcaseLinksBlockPill.displayName = 'PublicShowcaseLinksBlockPill';
